import { Controller, useFormContext } from "react-hook-form";
import { Select, SelectItem, SelectProps } from "@heroui/react";

function SelectMultipleInput({
    name,
    options,
    onAutosave,
    ...props
}: {
    name: string;
    options: { id: string | number; description: string | number }[];
    onAutosave?: () => void;
} & Partial<SelectProps>) {
    const { control } = useFormContext();
    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onBlur, onChange, value },
                fieldState: { error, invalid },
            }) => {
                return (
                    <Select
                        {...props}
                        onSelectionChange={(selection) => {
                            const ids = [...selection].map((key) => {
                                const parsed = Number(key);
                                return Number.isFinite(parsed) &&
                                    String(parsed) === String(key)
                                    ? parsed
                                    : key;
                            });
                            onChange(ids);
                            onAutosave?.();
                        }}
                        onBlur={onBlur}
                        isInvalid={invalid}
                        errorMessage={error?.message}
                        selectionMode="multiple"
                        selectedKeys={
                            new Set((value ?? []).map((key: string | number) => String(key)))
                        }
                    >
                        {options.map((option) => (
                            <SelectItem key={option.id}>
                                {option.description?.toString()}
                            </SelectItem>
                        ))}
                    </Select>
                );
            }}
        />
    );
}

export default SelectMultipleInput;
